












































import { ContractedSubscription } from '@/models/order/subscription/contracted/contracted-subscription'
import { formatPrice } from '@/util/format'
import Link from '@spa/components/atoms/Link.vue'
import { buildLabelFrom, Label } from '@spa/components/pages/mypage/subscription/contracted/list/model/list-item/label'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Link,
  },
})
export default class ContractedSubscriptionListItem extends Vue {
  @Prop({ required: true })
  contractedSubscription: ContractedSubscription

  readonly formatPrice = formatPrice

  get labels(): Label {
    return buildLabelFrom(this.contractedSubscription)
  }

  get detailPagePath(): string {
    return `/mypage/subscription/${this.contractedSubscription.id}`
  }
}
